import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import DefaultTemplate from "@/templates/default.vue";
import DarkTemplate from "@/templates/dark.vue";
import BasicTemplate from "@/templates/basic.vue";

import { getCurrentTemplate } from "./router/local-router";
import { onMounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentTemplate = ref(getCurrentTemplate());

const updateView = () => {
  currentTemplate.value = getCurrentTemplate();
};
onMounted(() => {
  window.addEventListener("pathchange", updateView);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (currentTemplate.value === 'default')
      ? (_openBlock(), _createBlock(DefaultTemplate, { key: 0 }))
      : _createCommentVNode("", true),
    (currentTemplate.value === 'dark')
      ? (_openBlock(), _createBlock(DarkTemplate, { key: 1 }))
      : _createCommentVNode("", true),
    (currentTemplate.value === 'basic')
      ? (_openBlock(), _createBlock(BasicTemplate, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})